export const TEXT_LINK_DISPLAY_NAME = "TextLink";
